<template>
  <div class="l-learn-self-read" v-if="element">
    <!-- 视频讲解 -->
    <LLearnVideo ref="LLearnVideo" class="self-read-vedio" v-if="isVideoExplain" :options="{
      vid: vid,
      autoplay: false,
      canstop: false,
      hidePlayBtn: true,
    }" @play="onPlay" @leavingFull="leavingFull">
      <!-- 当前题目进度 -->
      <LNumber :current="element.currentCount" :total="element.totalCount" class="l-topic-progress" />
    </LLearnVideo>

    <!-- 录音回答 -->
    <div class="lSoundRecording-btn">
      <lRecorder ref="recorder" v-show="status === 1" :options="recorderOptions" :btn-text="btnName" @result="onresult"
        @start="onstart" @init="onRecordInit" :allowManual="true" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import version from '@/utils/version'
import LLearnVideo from '../l-learn-video'
import lRecorder from '../../components/l-recorder'
import UPModel from '@/models/imgup'
import LNumber from '../../components/l-number'
import localKeyLock from '@/utils/localKeyLock'
import tip from '@/constants/tip'
const { mapActions, mapGetters } = createNamespacedHelpers('course')
const up = new UPModel()

export default {
  components: { LLearnVideo, lRecorder, LNumber },
  data() {
    return {
      LOCAL_STAGE_KEY: '',
      STAGE_KEY: 'SELF_READ',
      STAGE_LAST_KEY: 'SELF_READ_LAST_KEY',
      vid: '', //视频id
      isVideoExplain: false, //视频
      elements: '', //当前元素
      currentTestItem: {},
      audioData: '', //录音数据
      status: 0, // 0,1,2 录音按钮的状态
      duration: 0, //视频的时长和录音需要倒计时时长
      btnName: '点击按钮开始跟读',
      recordingIndex: 0,
      recordingIsClick: false, //录音时只能倒计时完成提交
      recorderOptions: {
        elementType: null,
        duration: null,
        keywords: '',
        text: '',
      },
      maxDuration: 170,
    }
  },
  computed: {
    ...mapGetters(['element', 'highWord', 'problemStatus']),
  },
  watch: {
    'element.ELEMENT_TYPE'(to) {
      if (to) {
        if (this.element.currentCount > this.element.totalCount) {
          this.$emit('next')
          localStorage.removeItem(this.LOCAL_STAGE_KEY)
          return
        }
        // 自读 大情景段自读
        this.currentTestItem = this.element.datas[this.element.currentCount - 1]
        this.btnName = '点击按钮开始自读'
        if (this.currentTestItem) {
          this._initVideo(this.currentTestItem.attrs.videoId)
          this.isVideoExplain = true
          // 如果存在缓存初始化页面
          this._initStage()
        }
      }
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    // 录音初始化成功
    onRecordInit() {
      // 触发开始
      this.$refs.recorder.start()
    },
    onstart() {
      this.$refs.LLearnVideo.onPlay()
    },
    // 录音完成
    onresult(audioData) {
      console.log('录音结果:', audioData)
      // 退出全屏
      this.onCancelFullScreen()
      this.audioData = audioData
      //结束之前播放
      this.$refs.LLearnVideo.onPlayEnd()
      if (audioData) {
        this._submit()
      } else {
        // 录音异常
        this._recordError()
      }
    },
    onPlay() {
      this.$refs.LLearnVideo.setVolume(0)
      if (version.isPC()) {
        this.$refs.LLearnVideo.onFullScreenClick()
      } else {
        this.$refs.LLearnVideo.onFullScreenClick()
      }
    },
    onPlayEnd() {
      this.$refs.LLearnVideo.onPlayEnd()
    },
    leavingFull(flag) {
      if (flag) {
        let microphoneVolume = document.querySelector('.microphoneVolume')
        if (microphoneVolume) {
          microphoneVolume.parentNode.removeChild(microphoneVolume)
        }
      }
    },
    //获取视频得时长
    async _initVideo() {
      let { data } = await up.aliInfo({
        vid: this.currentTestItem.attrs.videoId,
      })
      this.vid = this.currentTestItem.attrs.videoId //不同元素这里的获取的字段不一样
      this.recorderOptions.duration =
        parseFloat(data.duration) || this.maxDuration
      this.status = 1
    },
    onCancelFullScreen() {
      let full_screen = document.querySelector('.l-learn-video')
      if (full_screen.className.indexOf('isfullScreen') > -1) {
        full_screen.classList.remove('isfullScreen')
        let microphoneVolume = document.querySelector('.microphoneVolume')
        if (microphoneVolume) {
          microphoneVolume.parentNode.removeChild(microphoneVolume)
        }
      }
    },
    _recordError() {
      this.$lPrompt({
        message: tip.ZERO,
        cancelTxt: '',
        successTxt: this.$locale.重新开始,
        successFn: () => {
          this.status = 1
          this.$refs.LLearnVideo.onPlayEnd()
          this.$refs.LLearnVideo.dispose()
          this.$set(this, 'vid', this.currentTestItem.attrs.videoId)
          this.$refs.LLearnVideo._initPlayer()
          this.audioData = ''
          setTimeout(() => {
            this.onRecordInit()
          }, 200)
        },
        cancelFn: '',
      })
    },
    //提交答案
    _submit() {
      this.$refs.LLearnVideo.onPlayEnd()
      this.recordingIndex += 1
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: {
          eleId: this.currentTestItem.id,
          ...this.audioData,
        },
      })
        .then((data) => {
          this._nextQ(data.records[this.element.currentCount - 1])
        })
        .catch((err) => {
          this.$lPrompt({
            message: err.message || err.msg,
            successTxt: '确定',
            successFn: () => { },
          })
        })
    },
    //有缓存时候数据的渲染
    _initStage() {
      // 获取缓存中储存得需要重复作答得题目
      const currentValueKey = `${this.STAGE_KEY}_${this.element.RECORD_ID}_${this.currentTestItem.id}`
      this.LOCAL_STAGE_KEY = localKeyLock(this.STAGE_LAST_KEY, currentValueKey)
      let selfRead = JSON.parse(localStorage.getItem(this.LOCAL_STAGE_KEY))
      if (selfRead) {
        this.recordingIndex = 1
      }

      // 录音参数
      this.recorderOptions.elementType = this.element.type
      this.recorderOptions.text = this.currentTestItem.attrs.answerTxt
      this.recorderOptions.audioFileName = `${this.element.RECORD_ID}-${this.currentTestItem.id}`
    },
    //下一题的切换
    _nextQ() {
      if (this.element.currentCount >= this.element.totalCount) {
        this.$emit('next')
        localStorage.removeItem(this.LOCAL_STAGE_KEY)
      } else {
        localStorage.removeItem(this.LOCAL_STAGE_KEY)
        window.location.reload()
      }
    },
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
